import type { GetRequestsListResponse } from "@nlc/shared-types";

import { useQuery } from "@tanstack/react-query";

import { trashKeys } from "@/hooks/queryKeys";
import apiClient from "@/lib/api/client";

interface UseGetTrashedRequestsParams {
  direction?: "asc" | "desc";
  limit?: number;
  page?: number;
  search?: string;
  sortBy?: string;
}

export function useGetTrashedRequests({
  direction = "desc",
  limit = 25,
  page = 1,
  search,
  sortBy = "deleted_at",
}: UseGetTrashedRequestsParams) {
  return useQuery<GetRequestsListResponse>({
    queryFn: async () => {
      const params = new URLSearchParams({
        direction,
        limit: limit.toString(),
        onlyTrashed: "true",
        page: page.toString(),
        sortBy,
        tab: "all",
      });

      if (search) {
        params.append("search", search);
      }

      return await apiClient
        .url(`/requests/list?${params.toString()}`)
        .get()
        .json();
    },
    queryKey: trashKeys.requests({ direction, limit, page, search, sortBy }),
    refetchOnWindowFocus: false,
    staleTime: 30_000,
  });
}
